import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {keyBy, memoize} from 'lodash';
import {Icon, Table, Card, Button, Popup, Loader, Dropdown} from 'semantic-ui-react';
import {stockAdjustmentStates} from '../../../common/dictionaries/parameters';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import './list.scss';

const allStatus = 'ALL';

class StockAdjustmentsList extends Component {
  constructor(props) {
    super(props);
    const canSeeAllAdjustment = hasAccessPermission(
      props.permissions,
      resources.StockAdjustment,
      scopes.Approve
    );
    this.state = {
      'showAllAdjustment': canSeeAllAdjustment,
      'defaultState': canSeeAllAdjustment ? stockAdjustmentStates.sent : allStatus,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.StockAdjustment, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.search();
    this.props.fetchDescriptionMantainStockAdjusment();
  }

  search() {
    const {showAllAdjustment, defaultState} = this.state;
    const filters = {
      'showAllAdjustment': showAllAdjustment ? 'Si' : 'No',
    };
    if (defaultState !== allStatus) {
      filters.state = defaultState;
    }
    this.props.fetchStockAdjustmentsList(filters);
  }

  changeStatus(value) {
    this.setState({'defaultState': value}, () => this.search());
  }

  getStatusOptions() {
    const status = Object.keys(stockAdjustmentStates).map((item) => {
      return {'text': stockAdjustmentStates[item], 'value': stockAdjustmentStates[item]};
    });
    status.push({'text': 'TODOS', 'value': allStatus});
    return status;
  }

  renderEditOrApproveAction(state, code, jdeType) {
    const {permissions} = this.props;
    if (hasAccessPermission(permissions, resources.StockAdjustment, scopes.Approve) &&
     state === stockAdjustmentStates.sent) {
      return (
        <Popup
          trigger={
            <Link to={`/ajuste-stock-inventario/aprobar/${code}/${jdeType}`}>
              <Icon name='check' color='blue' size='large' />
            </Link>
          }
          content='Aprobar'
          position='top center'
          inverted
        />
      );
    }

    if (hasAccessPermission(permissions, resources.StockAdjustment, scopes.Edit) &&
      state === stockAdjustmentStates.enter) {
      return (
        <Popup
          trigger={
            <Link to={`/ajuste-stock-inventario/editar/${code}/${jdeType}`}>
              <Icon name='write' color='blue' size='large' />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />
      );
    }
    return null;
  }

  renderAdjustments() {
    const {list, optionsObject} = this.props;
    const selectDescription = memoize((value) => {
      if (optionsObject[value]) {
        return optionsObject[value].description;
      }
      return value.toUpperCase();
    });
  
    return list.map((element, index) => {
      const dateFormatted = moment(element.creationDate).format(dateFormatShow);
      
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.warehouse}</Table.Cell>
          <Table.Cell textAlign='center'>{element.reason} - {element.reasonDescription.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.jdeType} ({element.adjustmentType})</Table.Cell>
          <Table.Cell textAlign='center'>{element.jdeNumber}</Table.Cell>
          <Table.Cell textAlign='center'>{selectDescription(element.description)}</Table.Cell>
          <Table.Cell textAlign='center'>{element.creationUser.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{dateFormatted}</Table.Cell>
          <Table.Cell textAlign='center'>{element.state}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Popup
              trigger={
                <Link to={`/ajuste-stock-inventario/ver/${element.code}/${element.jdeType}`}>
                  <Icon name='eye' color='blue' size='large' />
                </Link>
              }
              content='Ver'
              position='top center'
              inverted
            />
            {this.renderEditOrApproveAction(element.state, element.code, element.jdeType)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrAdjustments() {
    const {loading, loadingListDescription} = this.props;

    if (loading || loadingListDescription) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderAdjustments();
  }
  
  renderCreateButton() {
    if (!hasAccessPermission(this.props.permissions, resources.StockAdjustment, scopes.Create)) {
      return;
    }

    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to={paths.StockAdjustmentNewForm}
      >
        Añadir nuevo
      </Button>
    );
  }

  renderStateFilter() {
    return (
      <Dropdown selection
        options={this.getStatusOptions()}
        search
        value={this.state.defaultState}
        onChange={(e, {value}) => this.changeStatus(value)}
        placeholder='Seleccione un Estado'
      />
    );
  }

  render() {
    return (
      <div className='stock-adjustment-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Ajuste de stock de Inventario</h2>
              <div className='title-bar-actions'>
                {this.renderStateFilter()}
                {this.renderCreateButton()}
              </div>
            </div>
          </div>
        </Card>
        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código de Ajuste</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Bodega</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Motivo</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Tipo de Documento JDE</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Numero de Orden JDE</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Usuario Creación</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Fecha Creación</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='action-column'>Acción</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
        
            <Table.Body>
              {this.renderLoaderOrAdjustments()}
            </Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const optionsObject = keyBy(state.stockAdjustmentsListDescription.list, 'id');

  return {
    optionsObject,
    'loading': state.stockAdjustmentsList.loading,
    'list': state.stockAdjustmentsList.list,
    'permissions': state.session.permissions,
    'loadingListDescription': state.stockAdjustmentsListDescription.loading,
  };
};

const {
  navigateTo,
  fetchStockAdjustmentsList,
  fetchDescriptionMantainStockAdjusment,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchStockAdjustmentsList,
  fetchDescriptionMantainStockAdjusment,
})(StockAdjustmentsList);
